<template>
  <div>
    <b-row class="v-clean">
      <b-col>
        <b-row>
          <b-col>
            <v-select-default
              item-text="name"
              item-value="id"
              :items="stock_groups"
              label="GRUPO"
              v-model="stock_group_id"
              @change="paginate"
            />
          </b-col>
          <b-col>
            <v-select
              outlined
              dense
              :items="[
                { id: null, name: 'TODOS' },
                { id: 'ATIVO', name: 'ATIVO' },
                { id: 'INATIVO', name: 'INATIVO' },
              ]"
              item-text="name"
              item-value="id"
              label="RESIDENTES ATIVO/INATIVO"
              @change="getResidents"
              v-model="status_resident"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="FILTRAR POR RESIDENTE"
              :items="residents"
              v-model="resident_id"
              @change="paginate"
            />
          </b-col>
          <b-col>
            <v-text-field-default
              type="date"
              label="DATA"
              v-model="date"
              @change="paginate"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="FILTRAR POR USUÁRIO"
              :items="users"
              v-model="user_id"
              @change="paginate"
            />
          </b-col>
        </b-row>
        <errors-messages :errors="errors" />
        <b-row>
          <b-col>
            <v-data-table
              :headers="headers"
              :items="items"
              dense
              :server-items-length="count"
              :options.sync="options"
              :footer-props="{
                'items-per-page-options': [25, 50, 100],
                'items-per-page-text': 'Mostrar',
              }"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum resultado corresponde aos filtros"
              no-results-text="Nenhum resultado corresponde aos filtros"
              @update:options="paginate"
            >
              <template v-slot:[`item.entity`]="{ item }">
                <div v-if="item.entity" class="row">
                  <div
                    v-for="k in Object.keys(item.entity)"
                    :key="k"
                    class="col-md-6 pt-0 pb-0 border-bottom"
                  >
                    <small>{{ item.fields[k] }}:</small>
                    <small
                      ><strong class="ml-2">{{ item.entity[k] }}</strong></small
                    >
                  </div>
                </div>
              </template>
              <template v-slot:[`item.user_id`]="{ item }">
                <small>{{
                  professionalClassCouncilValue(getUserById(item.user_id))
                }}</small>
              </template>
              <template v-slot:[`item.when`]="{ item }">
                <small>{{
                  item.when ? formatDate(item.when) : item.date_time
                }}</small>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <confirmation-dialog
                  v-if="permission('write', 'main_stock_reversal')"
                  :disabled="loadingExecute"
                  :loading="loadingExecute"
                  small
                  message-title="ESTORNAR?"
                  message-body="Deseja realmente estornar a movimentação?"
                  open-class="btn-delete"
                  open-left-icon="fa-history"
                  open-text="ESTORNAR"
                  @yes="execute(item)"
                />
              </template>
            </v-data-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";
import VSelectDefault from "../../../Components/VSelectDefault";
import VTextFieldDefault from "../../../Components/VTextFieldDefault";

import ConfirmationDialog from "../../../Components/ConfirmationDialog";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import permission from "../../../../lib/permission";

export default {
  name: "Transfer",

  components: {
    ErrorsMessages,
    VSelectDefault,
    VTextFieldDefault,
    ConfirmationDialog,
  },

  data() {
    return {
      status_resident: "ATIVO",
      // filtros
      table: "stocked_item",
      stock_group_id: "",
      date: "",

      stock_groups: [],
      users: [],
      residents: [],
      search: "",
      user_id: "",
      resident_id: "",

      headers: [
        { text: "Informações", value: "entity", sortable: false },
        { text: "Responsável", value: "user_id", sortable: false },
        { text: "Ocorrência", value: "when" },
        { text: "", value: "actions", sortable: false },
      ],
      items: [],
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ["when"],
        sortDesc: [true],
        multiSort: true,
        mustSort: false,
      },
      count: 0,

      errors: [],
      show: false,
      loading: false,
      loadingExecute: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,
    professionalClassCouncilValue,

    async retrieve() {
      await this.getGroups();
      await this.getUsers();
      await this.getResidents();
    },

    getUserById(id) {
      for (let user of this.users) {
        if (user.id == id) {
          return {
            id: user.professional_class_council_id,
            name: user.name,
            value: user.professional_class_council_value,
            cpf: user.cpf,
            office: user.office,
          };
        }
      }

      return {
        id: null,
        name: "DEMO",
        value: null,
        cpf: null,
        office: null,
      };
    },

    async getGroups() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/stock/groups");
        const { error, errors, stock_groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.stock_groups = [{ id: "", name: "TODOS" }, ...stock_groups];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getUsers() {
      try {
        this.loading = true;

        let response = await api.get("/rest-home/users");

        let { error, errors, users } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.users = [{ id: "", name: "TODOS" }, ...users];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        let { status_resident } = this;
        let params = { status_resident };
        let response = await api.get("/rest-home/residents", { params });

        let { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = [
            { id: "", name: "TODOS" },
            { id: "rest_home", name: "EMPRESA" },
            ...residents,
          ];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        let {
          table,
          options,
          search,
          user_id,
          resident_id,
          stock_group_id,
          date,
        } = this;

        let sortings = [];
        for (let i = 0; i < options.sortBy.length; i++) {
          let header = options.sortBy[i];
          let order = options.sortDesc[i] ? "desc" : "asc";
          sortings.push({ header, order });
        }

        sortings = JSON.stringify(sortings);

        let params = {
          table,
          user_id,
          resident_id,
          stock_group_id,
          date,
          search,
          page: options.page,
          items_per_page: options.itemsPerPage,
          sortings,
          action: "TRANSFER",
        };

        let response = await api.get("/rest-home/stock/reversal/history", {
          params,
        });
        let { error, errors, items, count } = response.data;

        if (error) {
          this.items = [];
          this.count = 0;
          this.errors = errors;
        } else {
          this.errors = [];
          this.items = items;
          this.count = count;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async execute(item) {
      try {
        this.loadingExecute = true;

        const data = { action: "TRANSFER", item };

        const response = await api.post("/rest-home/stock/reversal", data);

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.paginate();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingExecute = false;
      }
    },
  },
};
</script>
